import { gql } from "urql";

export const GET_OWNERSHIPS: any = gql(`
    query GetOwnerships($search: String) {
    GetOwnerships(search: $search) {
        _id
        name
        lastname
        email
        phone
        isBorrower
        loans {
        _id
        name
        progress
        type
        purpose
        ltv
        investmentExperience
        tasks {
            _id
            key
            name
            state
        }
        owner {
            _id
            name
            lastname
        }
        }
        entities {
        _id
        name
        }
    }
    }
`)

export const GET_OWNERSHIPS_BY_ENTITY: any = gql(`
    query GetOwnershipsByEntity($entityId: String!){
        GetOwnershipsByEntity(entityId: $entityId) {
            _id
            name
            lastname
            stakes
        }  
    }
`)

export const GET_OWNERSHIPS_BY_CREATOR: any = gql(`
    query GetOwnershipsByCreator{
        GetOwnershipsByCreator {
            _id
            name
            lastname
            stakes
            ssn
            phone
            email
            address
            dateBirth
            files {
                key
                name
                url
            }
        }  
    }
`)

export const GET_OWNERSHIP: any = gql(`
    query GetOwnership($ownershipId: String) {
        GetOwnershipById(ownershipId: $ownershipId) {
            _id
            name
            lastname
            email
            phone
            isBorrower
            loans {
            _id
            name
            progress
            type
            purpose
            ltv
            investmentExperience
            tasks {
                _id
                key
                name
                state
            }
            owner {
                _id
                name
                lastname
            }
            }
            entities {
                _id
                name
            }
        }
    }
`)

export const GET_LATEST_LOAN_DOCS: any = gql(`
    query GetLatestLoanDocs($ownershipId: String!) {
        GetLatestLoanDocs(ownershipId: $ownershipId) {
            _id
            name
            key
            loan {
              _id
            }
            file {
                key
                name
                url
            }
        }
    }
`)

